import { gql } from "@apollo/client";

export const GET_COUNTRIES = gql`
	query GetCountries {
		countries {
			nodes {
				id
				name
				code
				states {
					nodes {
						id
						name
						code
					}
				}
			}
		}
	}
`;

export const GET_STATES = gql`
	query GetStates($countryId: UUID!) {
		states(condition: { countryId: $countryId }) {
			nodes {
				id
				name
				code
			}
		}
	}
`;
